"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriberRestartIce = void 0;
const Connection_1 = require("./Connection");
const Tracks_1 = require("./Tracks");
const Listener_1 = require("./Listener");
const TransceiverController_1 = require("./TransceiverController");
class SubscriberRestartIce {
} // Inform mediaserver that ice restart is needed, subscriber ice failed
exports.SubscriberRestartIce = SubscriberRestartIce;
/* tslint:disable:max-classes-per-file */
class SfuSubscribingParticipantConnection extends Listener_1.default {
    constructor(sfuConnection, getTracks) {
        super();
        this.type = "SFU";
        this.closed = false;
        this.sfuConnection = sfuConnection;
        this.getTracks = getTracks;
    }
    negotiate(offerTracks, requestRemoteTracks) {
        return Promise.reject('cant negotiate remote sfu pc');
    }
    getStats(selector) {
        let tracks = this.getTracks();
        if (selector) {
            tracks = tracks.filter(t => t === selector);
        }
        const promises = Promise.all(tracks.map(t => this.sfuConnection.subscribing.getStats(t)));
        return new Promise((resolve, reject) => {
            promises.then(reports => {
                const ret = new Map();
                reports.forEach(report => {
                    report.forEach((v, k) => {
                        ret.set(k, v);
                    });
                });
                resolve(ret);
            }).catch(reject);
        });
    }
    close() {
        this.closed = true;
    }
    isClosed() {
        return this.closed;
    }
}
class SfuConnection extends Listener_1.default {
    constructor(publishing, subscribing, configuration) {
        super();
        this.participants = new Map();
        this.publishing = new Connection_1.default(publishing, configuration, true);
        const maxBitrates = {
            high: 5000000,
            medium: 300000,
            low: 50000,
        };
        this.publishing.sendEncodings.set(Tracks_1.TrackType.VIDEO, [
            { rid: "h", scaleResolutionDownBy: 1.0, maxBitrate: maxBitrates.high },
            { rid: "m", scaleResolutionDownBy: 2.0, maxBitrate: maxBitrates.medium },
            { rid: "l", scaleResolutionDownBy: 4.0, maxBitrate: maxBitrates.low },
        ]);
        if (configuration) {
            configuration.transceiverControllerFactory =
                (transceiver, type) => new TransceiverController_1.SfuTransceiverController(transceiver, type, configuration === null || configuration === void 0 ? void 0 : configuration.logger);
        }
        this.subscribing = new Connection_1.default(subscribing, configuration, true);
        this.trackDescriptions = new Map();
        const overrideOn = this.subscribing.signaling.on;
        subscribing.on = (signal) => {
            if (signal.constructor === Connection_1.Offer) {
                this.trackDescriptions.forEach((desc, mid) => {
                    const newDesc = signal.sdp.tracks && signal.sdp.tracks[mid];
                    if (!newDesc || (desc && newDesc.participantId !== desc.participantId)) {
                        if (this.participants.has(desc.participantId)) {
                            this.participants.get(desc.participantId).fire(new Connection_1.TrackRemoved(desc.type));
                        }
                    }
                });
                this.trackDescriptions = new Map();
                Object.keys(signal.sdp.tracks || {}).forEach((mid) => {
                    this.trackDescriptions.set(mid, signal.sdp.tracks[mid]);
                });
            }
            overrideOn(signal);
        };
        this.publishing.on((ev) => this.fire(ev));
        this.subscribing.on((ev) => {
            var _a;
            if (ev.constructor === Connection_1.TrackAdded) {
                const { mid, track } = ev;
                const { participantId, type } = this.trackDescriptions.get(mid);
                track.type = type;
                if (this.participants.has(participantId)) {
                    this.participants.get(participantId).fire(ev);
                }
            }
            if (ev.constructor === Connection_1.StateConnecting || ev.constructor === Connection_1.StateConnected) {
                if (ev.constructor === Connection_1.StateConnecting) {
                    // @ts-ignore
                    if (((_a = ev.event) === null || _a === void 0 ? void 0 : _a.target.iceConnectionState) === "failed") {
                        subscribing.emit(new SubscriberRestartIce());
                    }
                }
                this.participants.forEach(conn => conn.fire(ev));
            }
        });
    }
    negotiate(offerTracks, requestRemoteTracks) {
        return __awaiter(this, void 0, void 0, function* () {
            if (offerTracks) {
                return yield this.publishing.negotiate(offerTracks);
            }
            else if (requestRemoteTracks) {
                // return await this.subscribing.negotiate(undefined, requestRemoteTracks);
            }
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.publishing.connect([]);
        });
    }
    close() {
        this.publishing.close();
        this.subscribing.close();
    }
    isClosed() {
        return this.publishing.isClosed();
    }
    getStats(selector) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.publishing.getStats(selector);
        });
    }
    createConnection(participantId) {
        const conn = new SfuSubscribingParticipantConnection(this, () => {
            const tracks = [];
            this.trackDescriptions.forEach((t, mid) => {
                var _a;
                if (t.participantId === participantId) {
                    (_a = this.subscribing.pc) === null || _a === void 0 ? void 0 : _a.getTransceivers().filter(tr => tr.mid === mid).map(tr => tr.receiver.track).forEach(tr => tracks.push(tr));
                }
            });
            return tracks;
        });
        this.participants.set(participantId, conn);
        return conn;
    }
}
exports.default = SfuConnection;
//# sourceMappingURL=SfuConnection.js.map